import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { DEFAULT_BRAND_LOGO } from "@/lib/brandLogo";
import "./AuthMobileTopBar.css";

export default function AuthMobileTopBar({
  linkTestId = "auth-mobile-logo-link",
  logoTestId = "auth-mobile-logo-image",
  backTestId = "auth-mobile-back-button",
}) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate("/");
  };

  return (
    <header className="auth-mobile-topbar" data-testid="auth-mobile-topbar">
      <button
        type="button"
        className="auth-mobile-topbar__back"
        data-testid={backTestId}
        aria-label="뒤로가기"
        onClick={handleBack}
      >
        <ArrowLeft size={20} aria-hidden="true" />
        <span>뒤로</span>
      </button>
      <Link to="/" className="auth-mobile-topbar__logo" data-testid={linkTestId}>
        <img
          src={DEFAULT_BRAND_LOGO}
          alt="DSiteSolution"
          data-testid={logoTestId}
          className="auth-mobile-topbar__logo-img"
          decoding="sync"
          fetchPriority="high"
        />
      </Link>
      <span className="auth-mobile-topbar__spacer" aria-hidden="true" />
    </header>
  );
}
